import Vue from 'vue/dist/vue';
import { customDirective } from './customDirective';
import globalNav from './globalNav.vue';
import languageButton from './languageButton.vue';
import gdpr from './gdpr.vue';
import pagetop from './pagetop.vue';
import navColumn3Wrap from './navColumn3Wrap.vue';
import navColumn3 from './navColumn3.vue';

export default function vueApp() {
  // eslint-disable-next-line no-new
  new Vue({
    el: '#app',
    components: {
      globalNav,
      languageButton,
      gdpr,
      pagetop,
      navColumn3Wrap,
      navColumn3,
    },
    mixins: [customDirective],
  });
}
